import { create } from 'zustand';

/**
 * Single source of truth for the feedback dialog's open state, so the
 * dialog can be triggered from more than one place without duplicating
 * it. The floating FeedbackWidget FAB owns the dialog markup and reads
 * this; surfaces that have no room for the FAB (the /assistant
 * workspace, which hides it) open feedback from their own chrome via
 * `openFeedback()`.
 */
interface FeedbackStore {
  open: boolean;
  openFeedback: () => void;
  setOpen: (open: boolean) => void;
}

export const useFeedbackStore = create<FeedbackStore>((set) => ({
  open: false,
  openFeedback: () => set({ open: true }),
  setOpen: (open) => set({ open }),
}));
